import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PowerBiEmbed from "./PowerBiEmbed";
import { Button } from "antd";

const PowerBiReportPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const report = location.state;

  if (!report) {
    return <div>No report data found.</div>;
  }

  return (
    <div>
      <Button onClick={() => navigate(-1)} style={{ margin: "1rem" }}>
        ← Back
      </Button>
      <PowerBiEmbed link={report.link} />
    </div>
  );
};

export default PowerBiReportPage;
